// @ts-ignore
import { SemVer, InformationalVersion, CommitDate, FullSemVer, ShortSha } from '../../../../version.json';
import { GitVersionInfo } from '../../../../generated/signalR/git-version-info';

export const SamwinVersion = {
   VERSION: <GitVersionInfo>{
      informationalVersion: String(InformationalVersion),
      commitDate: String(CommitDate),
      fullSemVer: String(FullSemVer),
      semVer: String(SemVer),
      shortSha: String(ShortSha),
   },
};
